import { Component, Input, OnInit, ViewChild, EventEmitter, Output, OnDestroy } from '@angular/core';
import { CustomField } from '../../basics/custom-field/custom-field-model';
import { NgForm } from '@angular/forms';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { map } from 'rxjs/operators';
import { ContactList } from '../contact-list.model';
import { CustomFieldEdit } from '../custom-field-edit.model';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'contact-list-edit',
  templateUrl: './contact-list-edit.component.html',
  styleUrls: ['./contact-list-edit.component.css']
})

export class ContactListEditComponent implements OnInit, OnDestroy {
  @ViewChild('editForm', { static: false }) editForm: NgForm;

  private customFields: CustomField[] = [];
  private contactList: ContactList = new ContactList();
  private editCustomFields: CustomFieldEdit[] = [];
  private subs = new SubSink();

  private isNew: boolean = true;
  private modal: any;
  private selectedCompany: number;

  @Output()
  private saved: EventEmitter<ContactList> = new EventEmitter<ContactList>();

  constructor(private repository: HttpRepositoryService, private antiForgery: AntiForgeryTokenService) { }

  ngOnInit() {
    this.modal = $('#contactListForm');

    this.subs.sink = this.repository.get<CustomField[]>('api/CustomField/List').pipe(map(x => x.data))
      .subscribe(fields => {
        this.customFields = fields;
      });
  }

  public show(contactList: ContactList, isNew: boolean, selectedCompany: number) {
    this.editForm.reset();
    this.contactList = contactList;
    this.isNew = isNew;
    this.selectedCompany = selectedCompany;

    var fields: CustomFieldEdit[] = [];
    for (var i = 0; i < this.customFields.length; i++) {
      var edit = new CustomFieldEdit();
      edit.id = this.customFields[i].id;
      edit.name = this.customFields[i].name;
      edit.type = this.customFields[i].type;
      fields.push(edit);
    }

    if (!this.isNew) {
      for (var i = 0; i < fields.length; i++) {
        var field = this.contactList.customFields.find(x => x.idCustomField === fields[i].id);
        if (field) {
          fields[i].isChecked = true;
          fields[i].isRequired = field.isRequired;
        }
      }
    }

    this.editCustomFields = fields;

    this.modal.modal({
      show: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  private save() {
    if (this.editForm.valid) {
      this.contactList.customFields = [];
      for (var i = 0; i < this.editCustomFields.length; i++) {
        if (this.editCustomFields[i].isChecked) {
          this.contactList.customFields.push({ idCustomField: this.editCustomFields[i].id, name: this.editCustomFields[i].name, type: this.editCustomFields[i].type, isRequired: this.editCustomFields[i].isRequired });
        }
      }
      if (this.isNew) {
        this.insert();
      } else {
        this.update();
      }
    } else {
      Object.keys(this.editForm.controls)
        .forEach(fieldName => {
          this.editForm.controls[fieldName].markAsDirty();
        });
      $('#name').focus();
    }
  }

  private insert(): void {
    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Create contact list', 'error');
      } else {
        this.subs.sink = this.repository.post<ContactList>('api/ContactList/Create?companyId=' + this.selectedCompany, this.contactList, afResp.data).subscribe(resp => {
          if (resp.hasErrors) {
            Toast.Show(resp.error, 'Create contact list', 'error');
          } else {
            Toast.Show('Contact list created successfully.', 'Create contact list', 'success');
          }

          this.onSaveCompleted(resp.data);
        });
      }
    });
  }

  private update() {
    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Update contact list', 'error');
      } else {
        this.subs.sink = this.repository.put<ContactList>('api/ContactList/Edit?companyId=' + this.selectedCompany, this.contactList, afResp.data).subscribe(resp => {
          if (resp.hasErrors) {
            Toast.Show(resp.error, 'Update contact list', 'error');
          } else {
            Toast.Show('Contact list updated successfully.', 'Update contact list', 'success');
          }

          this.onSaveCompleted(resp.data);
        });
      }
    });
  }

  private onSaveCompleted(data: ContactList) {
    this.close();
    this.saved.emit(data);
  }

  close() {
    this.modal.modal('hide');
    this.contactList = new ContactList();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
